// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class TokenGroup {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        this.id = model.persistentId;
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        this.idInVersion = model.id;
        this.brandId = model.brandId;
        this.designSystemVersionId = model.designSystemVersionId;
        this.name = model.meta.name;
        this.description = model.meta.description || "";
        this.isRoot = model.isRoot;
        this.tokenType = model.tokenType;
        this.childrenIds = model.childrenIds;
        this.path = new Array();
        this.tokenIds = new Array();
        this.subgroupIds = new Array();
        this.parentGroupId = null;
        // Set unordered when constructing
        this.sortOrder = -1;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    addChild(groupId) {
        this.subgroupIds.push(groupId);
    }
    addChildren(groupsIds) {
        this.subgroupIds = this.subgroupIds.concat(groupsIds);
    }
    setPath(segments) {
        this.path = segments;
    }
    setParentGroupId(parentGroupId) {
        this.parentGroupId = parentGroupId !== null && parentGroupId !== void 0 ? parentGroupId : null;
    }
    setSortOrder(order) {
        this.sortOrder = order;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Write
    toWriteObject() {
        return {
            id: this.idInVersion,
            brandId: this.brandId,
            tokenType: this.tokenType,
            designSystemVersionId: this.designSystemVersionId,
            persistentId: this.id,
            isRoot: this.isRoot,
            meta: {
                name: this.name,
                description: this.description,
            },
            childrenIds: this.childrenIds,
        };
    }
    toMutatedObject(childrenIds) {
        const group = new TokenGroup({
            id: this.idInVersion,
            brandId: this.brandId,
            tokenType: this.tokenType,
            designSystemVersionId: this.designSystemVersionId,
            persistentId: this.id,
            isRoot: this.isRoot,
            meta: {
                name: this.name,
                description: this.description,
            },
            childrenIds,
        });
        group.parentGroupId = this.parentGroupId;
        group.sortOrder = this.sortOrder;
        return group;
    }
}
